export async function getMarkdownText(filename: string): Promise<string> {
  return fetch(`/assets/${filename}`)
    .then((response) => response.text())
    .then((text) => text.replace(/<!---[\s\S]*-->/g, ""));
}
